import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {roleActions} from "../../../actions/role.actions";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Link} from "react-router-dom";
import {connect} from "react-redux";

class RoleCreatePage extends Component {

    state = {
        label: null,
        description: null,
        isSuperAdmin: false,
    };

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };

    handleOnChangeCheckbox = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.checked
        })
    }

    handleOnSubmit = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;
        dispatch(roleActions.createRole(this.state));
    };

    render() {
        const { t } = this.props;

        const breadcrumb = [
            { value: 'roles', path: '/panel/role' },
            { value: 'create', path: '#' }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('roles') }</h4>
                <h5>{ t('create') }</h5>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link to={"/panel/role"}>
                                <button className="btn btn-secondary float-right">
                                    <i className="fas fa-undo"> </i> <span>{t('back-to-list')}</span>
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        <form className="row" onSubmit={this.handleOnSubmit}>
                            <div className="col-md-5">
                                <div className="form-group">
                                    <label className="col-form-label">{ t('label') }</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="label"
                                        value={this.state.label || ''}
                                        onChange={this.handleOnChangeInput}
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="col-form-label">{ t('description') }</label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={this.state.description || ''}
                                        onChange={this.handleOnChangeInput}
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="col-form-label">{ t('isSuperAdmin') }</label>
                                    <input
                                        type="checkbox"
                                        className="form-check"
                                        name="isSuperAdmin"
                                        checked={this.state.isSuperAdmin || false}
                                        onChange={this.handleOnChangeCheckbox}
                                    />
                                </div>

                                <div className="form-group">
                                    <button type="submit" className="btn btn-success">
                                        <i className="fas fa-plus"> </i> {t('create')}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {}
};
export default withNamespaces()(connect(mapStateToProps)(RoleCreatePage));
